import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import type { ArtKrankenVersicherung, PauschalbesteuerungGeringfuegig } from '../../../../db/enums/misc-enums.js';
import { AGArbeit } from './ag-arbeit.js';
import { AGAuslandBeschaftigung } from './ag-auslandbeschaftigung.js';
import { AGBeschaftigung } from './ag-beschaftigung.js';

export enum BetriebsnummerAbweichendeKrankenkasseBeiGeringfuegig {
  NONE = 'Kein Geringverdiener',
  GERING = 'Geringverdiener',
  GERING_BESCHAEFTIGT = 'Geringfuegig Beschäftigt, meldepflichtig, kurzfrist. Beschäft. meldepflichtig',
}

export enum VersicherungsstatusKurzfristigBeschaeftigte {
  GESETZLICH = 'Gesetzlich Krankenversichtert',
  PRIVAT = 'Privat Krankenversichert',
  ANDERWEITIG = 'Anderweitig im Krankheitsfall abgesichert',
}

@Entity()
export class ANGeringfuegigeBeschaeftigung extends AdornisEntity {
  static override _class = 'ANGeringfuegigeBeschaeftigung';

  @Field(() => Boolean, { default: v => v ?? false })
  geringfuegigeBeschaeftigungGewuenscht: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  befreiungRentenversicherungspflichtGewuenscht: Maybe<boolean>;

  @Field(() => String)
  pauschalbesteuerungGeringfuegig: Maybe<PauschalbesteuerungGeringfuegig>;

  @Field(() => String)
  pauschalbesteuerungGeringfuegigSonstige: Maybe<string>;

  @Field(() => Boolean, { default: v => v ?? false })
  beschaeftigungslos: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  beschaefitgungslosLeistungsbezug: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  krankenversicherung: Maybe<boolean>;

  @Field(() => String)
  artKrankenversicherung: Maybe<ArtKrankenVersicherung>;

  @Field(() => Boolean, { default: v => v ?? false })
  beschaftigung: Maybe<boolean>;

  @Field(() => [AGBeschaftigung], {
    default: v => v ?? [],
  })
  beschaeftigungen: Maybe<AGBeschaftigung[]>;

  @Field(() => Boolean, { default: v => v ?? false })
  arbeit: Maybe<boolean>;

  @Field(() => [AGArbeit], {
    default: v => v ?? [],
  })
  arbeits: Maybe<AGArbeit[]>;

  @Field(() => Boolean, { default: v => v ?? false })
  auslandsbeschaeftigung: Maybe<boolean>;

  @Field(() => [AGAuslandBeschaftigung], {
    default: v => v ?? [],
  })
  auslandbeschaeftigung: Maybe<AGAuslandBeschaftigung[]>;

  @Field(() => Boolean, { default: v => v ?? false })
  beantrageBefreiungRentenversicherung: Maybe<boolean>;

  @Field(() => Boolean, { default: v => v ?? false })
  istAltersvollrentner: Maybe<boolean>;

  @Field(() => String)
  geringfuegigKrankenkasseBetriebsnummer: Maybe<BetriebsnummerAbweichendeKrankenkasseBeiGeringfuegig>;

  @Field(() => String)
  versicherungsstatusKurzfristigBeschaeftigt: Maybe<VersicherungsstatusKurzfristigBeschaeftigte>;
}
